/**
 * 사업자 번호 10자리 수 '-' 처리
 * @param number 숫자 값
 * @example
 *  formatBusinessNumber(1234567890) // 123-45-6789
 */

export default function formatBusinessNumber(number: number | string) {
  let numberStr = number.toString();

  // 기존에 입력된 "-" 기호가 있다면 제거
  numberStr = numberStr.replace(/-/g, '');

  if (numberStr.length !== 10) {
    console.log('Invalid number, 10자리 미만의 사업자 번호를 등록 했습니다.');
    return '';
  }

  const formattedNumber = `${numberStr.slice(0, 3)}-${numberStr.slice(
    3,
    5,
  )}-${numberStr.slice(5)}`;

  return formattedNumber;
}
